import { WebStorageNames } from "./constants";
import { WebStorage } from "./webStorage";

function readOnboardingFlagFromStorage() {
  const stored =
    WebStorage.getLocalStore(WebStorageNames.IsAnnualLeavePopupShown) ??
    WebStorage.getLocalStore("isAnnualLeavePopupShown");

  if (stored === null || stored === undefined || stored === "") {
    return null;
  }
  if (stored === true || stored === false) {
    return stored;
  }
  if (typeof stored === "string") {
    const trimmed = stored.trim();
    if (trimmed === "true") return true;
    if (trimmed === "false") return false;
    try {
      return JSON.parse(trimmed);
    } catch {
      return false;
    }
  }
  return !!stored;
}

/**
 * Whether the company admin has finished first-time onboarding.
 */
export function isAdminOnboardingComplete(isAnnualLeavePopupShownFromRedux) {
  if (isAnnualLeavePopupShownFromRedux === true) {
    return true;
  }

  const fromStorage = readOnboardingFlagFromStorage();
  if (fromStorage === true) {
    return true;
  }

  return false;
}

export function needsAdminOnboarding(isAnnualLeavePopupShownFromRedux) {
  return !isAdminOnboardingComplete(isAnnualLeavePopupShownFromRedux);
}

/** Where to send a company admin immediately after login or register. */
export function getAdminPostAuthPath(companyInfo, isAnnualLeavePopupShown) {
  if (needsAdminOnboarding(isAnnualLeavePopupShown)) {
    return "/onboarding";
  }
  if (companyInfo?.name) {
    return `/${companyInfo.name}/offices`;
  }
  return "/workplaces";
}
